import { useCallback, useEffect, useState } from 'react'
import { useStores } from '../../data/store'
import { useNav } from '../../nav/NavService'

const PreventBack = ({ handleDrawer, isDrawerOpen }: { handleDrawer?: () => void; isDrawerOpen?: boolean }) => {
  const [showAlert, setShowAlert] = useState(false)

  const { isModalDisplaying, updateCancelModal, showPopup } = useStores((root) => ({
    showPopup: root?.config?.showPopup,
    isModalDisplaying: root?.config?.isModalDisplaying,
    updateCancelModal: root?.config?.updateCancelModal,
  }))

  const handleBack = useCallback(() => {
    if (!showAlert) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useNav().back(1)
      if (isModalDisplaying) {
        updateCancelModal(true)
      } else {
        console.log('isModalDisplaying', isModalDisplaying)
        if (isModalDisplaying) {
          updateCancelModal(true)
        } else {
          console.log('isModalDisplaying1 ', showPopup, isDrawerOpen)
          window.history.pushState(null, '', window.location.pathname)
          if (showPopup && isDrawerOpen) {
            setShowAlert(true)
          } else {
            if (showPopup && handleDrawer) {
              handleDrawer()
            }
          }
        }
      }
    }
  }, [handleDrawer, isDrawerOpen, isModalDisplaying, showAlert, showPopup, updateCancelModal])

  useEffect(() => {
    window.addEventListener('popstate', handleBack)
    window.history.pushState(null, '', window.location.pathname)
    return () => {
      window.removeEventListener('popstate', handleBack)
    }
  }, [handleBack])

  return <></>
}

export { PreventBack }
